module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADvSURBVHgB7ZVBDoIwEEWnEPceoUtcmFRvwMm9Qpfs7BHcaWKkdhATKQP9NbiSv4Cm7f+PlGlLtCpXWpstLSgVd+z2xzO//b2tm8Y6AlRVRqtNceL2tWwPztrLe6wYT/f86AxsJDxcs/czXAT40tfh6RBIFO5e3qGUaDTB+FDBqIKRnLRcUnhjx0sqAlIQNHwWMAXpTGB4EiBB+m4oHAIIEELDWQUhusXfovq+tNJLFP3Q3hbacnVlAabqPFXCEGCuFJF9MgtA6hyFqG/CcyCjKsrZRDwWn13xnAHAGL4L+DTF63wI8fRTabPsZfUnegIlL+U0dmRyzwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/close.png
// module id = vq1L
// module chunks = 0